import React, { useState } from 'react';
import axios from 'axios';

const FileUploader: React.FC = () => {
  const [file, setFile] = useState<File | null>(null);
  const [progress, setProgress] = useState<number>(0);
  const [timeRemaining, setTimeRemaining] = useState<string>('');

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const uploadFile = async () => {
    if (!file) {
      alert('Please select a file to upload.');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await axios.post(
        `http://localhost:8081/bunny/upload/temp`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            if (progressEvent.total) {
              const percentage = Math.round(
                (progressEvent.loaded / progressEvent.total) * 100,
              );
              const elapsedTime = performance.now() / 1000; // seconds
              const estimatedTotalTime = elapsedTime / (percentage / 100);
              const remainingTime = estimatedTotalTime - elapsedTime;

              setProgress(percentage);
              setTimeRemaining(`${remainingTime.toFixed(2)} seconds`);
            }
          },
        },
      );
      console.log('Upload Response:', response.data);
    } catch (err) {
      console.error('Upload Error:', err);
    }
  };

  return (
    <div>
      <h1>File Upload with BunnyCDN</h1>
      <input type="file" onChange={handleFileChange} />
      <button onClick={uploadFile}>Upload</button>
      <div>
        {progress > 0 && (
          <div>
            <p>Progress: {progress}%</p>
            <p>Estimated Time Remaining: {timeRemaining}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FileUploader;
